import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/Woveon",
      name: "Woveon",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Woveon" */ "./views/Projects/Woveon.vue")
    },
    {
      path: "/Busbuddy",
      name: "Busbuddy",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Busbuddy" */ "./views/Projects/Busbuddy.vue")
    },
    {
      path: "/ColoredSpace",
      name: "ColoredSpace",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "ColoredSpace" */ "./views/Projects/ColoredSpace.vue")
    },
    {
      path: "/532m",
      name: "532m",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "532m" */ "./views/Projects/532m.vue")
    },
    {
      path: "/Neoprene",
      name: "Neoprene",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Neoprene" */ "./views/Projects/Neoprene.vue")
    },
    {
      path: "/TurningStool",
      name: "TurningStool",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "TurningStool" */ "./views/Projects/TurningStool.vue")
    },
    {
      path: "/Watney",
      name: "Watney",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Watney" */ "./views/Projects/Watney.vue")
    },
    {
      path: "/HYPRMobileApp",
      name: "HYPRMobileApp",

      // component: () =>
      //   import(/* webpackChunkName: "WIP" */ "./views/WIP.vue")

      // links outside to notion / sotion + cloak.ist workaround
      beforeEnter() {
        location.href = "https://hyprmobile.robbeyorth.com";
      }
    },
    {
      path: "/HYPRBrandDesignSystem",
      name: "HYPRBrandDesignSystem",

      // component: () =>
      //   import(/* webpackChunkName: "WIP" */ "./views/WIP.vue")

      // links outside to notion / sotion + cloak.ist workaround
      beforeEnter() {
        location.href = "https://hyprbrand.robbeyorth.com";
      }
    },
    {
      path: "/HYPRControlCenter",
      name: "HYPRControlCenter",

      // component: () =>
      //   import(/* webpackChunkName: "WIP" */ "./views/WIP.vue")

      // links outside to notion / sotion + cloak.ist workaround
      beforeEnter() {
        location.href = "https://hyprcontrolcenter.robbeyorth.com";
      }
    }
  ],
  //   scrollBehavior(to, from, savedPosition) {
  //     return {
  //         x: 0,
  //         y: 0,
  //     };
  // },

  scrollBehavior(to, from) {
    if (from.name == "Home" && to.path == "/" && !to.hash) {
      // console.log("top");
      return window.scrollTo({ top: 0, behavior: "smooth" });
    }
    if (to.hash) {
      return "";
    }
    // if (to.hash) {
    //   // console.log(to);
    //   // console.log("hash: " + to.hash);
    //   return window.scrollTo({
    //     top: document.querySelector(to.hash).offsetTop,
    //     behavior: "smooth"
    //   });
    // }
    return window.scrollTo({ top: 0 });
  }

  // scrollBehavior(to) {
  //   if (to.hash) {
  //     return { selector: to.hash, behavior: 'smooth' };
  //   }
  //   return { x: 0, y: 0 };
  // }
});
